// The outer dimension of the indicator in its default state (border inside)
// in the SVG coordinate space. Custom values are used here over tokens to
// ensure pixel-perfect positioning and rendering on low DPI displays.
const indicatorSize = {
    xsmall: 14,
    small: 16, // Equals to sds-size-xsmall
    medium: 18,
    large: 22,
    xlarge: 28, // Equals to sds-size-large
};

export { indicatorSize };
//# sourceMappingURL=constants.js.map
